import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { create } from '../../../common/v4/BackendProvider';
import { EditPage, EditPageTextField, EditPageCheckbox, EditPageSelect, EditPagePanel } from './../../../common/EditPage';

const SmsMasterCodeCreate = () => {
    const navigate = useNavigate();
    const [data, setData] = useState({
        ATRDESTCODE: '',
        ATRNAME: '',
        ATRISOCOUNTRY: '',
        ATRSTATUS: '1'
    });
    
    const handleSave = () => {
        create('/admin/products/sms_master_codes', {data: data}).then(response => {
            toast.success("SMS Master Code created successfully", {});
            navigate('/products/sms_master_codes');
        }).catch(error => {
            toast.error("Error creating SMS Master Code: " + error.message, {});
        });
    }
    const handleCancel = () => {
        navigate('/products/sms_master_codes');
    }
    const onChange = (id, value) => {
        setData({ ...data, [id]: value });
    }
    return (
        <div>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                closeOnClick={true}
                pauseOnHover={true}
                draggable={true}
                progress="undefined"
            />
            <EditPage handleSave={ handleSave } handleCancel={ handleCancel } title="Create SMS Master Code" >
                <EditPagePanel>
                    <EditPageTextField label="Name" id="ATRNAME" onChange={ onChange } value={ data.ATRNAME } />
                    <EditPageTextField label="ISO Code" id="ATRISOCOUNTRY" onChange={ onChange } value={ data.ATRISOCOUNTRY } />
                    <EditPageCheckbox label="Status" id="ATRSTATUS" onChange={ onChange } value={ data.ATRSTATUS } />
                </EditPagePanel>
            </EditPage>
        </div>
    )
}   

export default SmsMasterCodeCreate;